import { render, staticRenderFns } from "./customer-case.vue?vue&type=template&id=e2693e34&"
import script from "./customer-case.js?vue&type=script&lang=js&"
export * from "./customer-case.js?vue&type=script&lang=js&"
import style0 from "./customer-case.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports